const opt = (...xs) => xs.map((x) => (Array.isArray(x) ? { value: x[0], label: x[1] } : { value: x, label: x }));

export const TRUST_STATUS = opt(["bozza", "Bozza"], ["istituito", "Istituito"], ["attivo", "Attivo"], ["sospeso", "Sospeso"], ["cessato", "Cessato"]);
export const SUBJECT_ROLES = opt(["disponente", "Disponente"], ["trustee", "Trustee"], ["beneficiario", "Beneficiario"],
  ["guardiano", "Guardiano"], ["protettore", "Protettore"], ["apportatore", "Apportatore"], ["beneficiario_finale", "Beneficiario finale"],
  ["beneficiario_attuale", "Beneficiario attuale"], ["beneficiario_reddito", "Beneficiario del reddito"], ["costituente", "Costituente"], ["altro", "Altro"], ["da_definire", "Da definire"]);

export const GR_STATUS = opt(["iscritto", "Iscritto"], ["in_coda", "Iscrizione in corso"], ["rimosso", "Rimosso"], ["errore", "Errore"], ["non_configurato", "Non configurato"]);

export const subjectName = (s) => (s ? (s.type === "societa" ? s.company_name : `${s.last_name || ""} ${s.first_name || ""}`.trim()) || s.company_name || "—" : "—");

export const ENTITY_DEFS = {
  trusts: {
    title: "Progetti Trust", singular: "Trust",
    fields: [
      { k: "name", l: "Denominazione", req: true }, { k: "code", l: "Codice" },
      { k: "typology", l: "Tipologia", t: "select", o: opt("Familiare", "Di Scopo", "Liberale", "Commerciale", "Altro") },
      { k: "status", l: "Stato", t: "select", o: TRUST_STATUS }, { k: "governing_law", l: "Legge regolatrice" },
      { k: "tax_code", l: "Codice fiscale" }, { k: "client_name", l: "Cliente di riferimento" }, { k: "duration", l: "Durata" },
      { k: "establishment_date", l: "Data istituzione", t: "date" }, { k: "start_date", l: "Data inizio", t: "date" },
      { k: "end_date", l: "Data fine", t: "date" }, { k: "purpose", l: "Scopo", t: "textarea" },
      { k: "description", l: "Descrizione", t: "textarea" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["code", "name", "typology", "status", "governing_law", "client_name"],
  },
  subjects: {
    title: "Anagrafiche", singular: "Soggetto",
    fields: [
      { k: "type", l: "Tipo", t: "select", o: opt(["persona_fisica", "Persona fisica"], ["societa", "Società / Ente"]) },
      { k: "last_name", l: "Cognome" }, { k: "first_name", l: "Nome" }, { k: "company_name", l: "Ragione sociale" },
      { k: "tax_code", l: "Codice fiscale" }, { k: "vat_number", l: "Partita IVA" }, { k: "birth_date", l: "Data di nascita", t: "date" },
      { k: "birth_place", l: "Luogo di nascita" }, { k: "birth_province", l: "Provincia di nascita" }, { k: "nationality", l: "Nazionalità" },
      { k: "address", l: "Indirizzo" }, { k: "city", l: "Città" }, { k: "province", l: "Provincia" }, { k: "postal_code", l: "CAP" },
      { k: "country", l: "Paese" }, { k: "phone", l: "Telefono / cellulare" }, { k: "email", l: "Email" }, { k: "pec", l: "PEC" },
      { k: "whatsapp_consent", l: "Consenso comunicazioni WhatsApp", t: "bool" }, { k: "whatsapp_consent_date", l: "Data consenso WhatsApp", t: "date" },
      { k: "marketing_consent", l: "Consenso marketing (newsletter GetResponse)", t: "bool" }, { k: "marketing_consent_date", l: "Data consenso marketing", t: "date" },
      { k: "marketing_consent_source", l: "Fonte del consenso", t: "select", o: opt("Modulo firmato", "Email", "Sito web", "Colloquio", "Altro") },
      { k: "gr_status", l: "GetResponse", t: "select", ro: true, o: GR_STATUS },
      { k: "id_doc_type", l: "Tipo documento", t: "select", o: opt("Carta d'identità", "Patente", "Passaporto") },
      { k: "id_doc_number", l: "Numero documento" }, { k: "id_doc_issue_date", l: "Data rilascio", t: "date" },
      { k: "id_doc_expiry_date", l: "Data scadenza", t: "date" }, { k: "id_doc_issued_by", l: "Rilasciato da" },
      { k: "marital_status", l: "Stato civile" }, { k: "property_regime", l: "Regime patrimoniale", t: "select", o: opt("Comunione dei beni", "Separazione dei beni") },
      { k: "occupation", l: "Professione" }, { k: "client_relationship", l: "Rapporto con il cliente" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["_name", "tax_code", "email", "phone", "city", "gr_status"],
  },
  trust_subjects: {
    title: "Soggetti del Trust", singular: "Collegamento",
    fields: [
      { k: "subject_id", l: "Soggetto", t: "subject", req: true }, { k: "role", l: "Ruolo", t: "select", o: SUBJECT_ROLES, req: true },
      { k: "start_date", l: "Dal", t: "date" }, { k: "end_date", l: "Al", t: "date" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["subject_id", "role", "start_date", "end_date"],
  },
  assets: {
    title: "Patrimonio", singular: "Bene",
    fields: [
      { k: "category", l: "Categoria", t: "select", req: true, o: opt(["fabbricato", "Fabbricato"], ["terreno", "Terreno"], ["partecipazione", "Partecipazione"], ["liquidita", "Liquidità"], ["mobile", "Bene mobile"], ["altro", "Altro"]) },
      { k: "code", l: "Codice (F1, T1…)" }, { k: "description", l: "Descrizione", req: true, t: "textarea" }, { k: "asset_type", l: "Tipologia" },
      { k: "city", l: "Comune" }, { k: "cadastral_data", l: "Dati catastali" }, { k: "cadastral_category", l: "Categoria catastale" },
      { k: "cadastral_income", l: "Rendita catastale", t: "number" }, { k: "cadastral_value", l: "Valore catastale", t: "number" },
      { k: "value", l: "Valore", t: "number" }, { k: "valuation_date", l: "Data valutazione", t: "date" },
      { k: "contributor_id", l: "Apportatore", t: "subject" }, { k: "contribution_type", l: "Tipo apporto", t: "select", o: opt("PIENA PROPRIETÀ", "NUDA PROPRIETÀ", "USUFRUTTO") },
      { k: "contribution_date", l: "Data apporto", t: "date" }, { k: "contribution_value", l: "Valore apporto", t: "number" },
      { k: "fund", l: "Fondo" }, { k: "in_trust", l: "In Trust", t: "bool" }, { k: "exit_date", l: "Data uscita", t: "date" },
      { k: "exit_reason", l: "Motivo uscita" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["code", "category", "description", "city", "value"],
  },
  accounting: {
    title: "Contabilità", singular: "Registrazione",
    fields: [
      { k: "date", l: "Data", t: "date", req: true }, { k: "description", l: "Descrizione", req: true }, { k: "account", l: "Conto", t: "account", req: true },
      { k: "debit", l: "Dare", t: "number" }, { k: "credit", l: "Avere", t: "number" }, { k: "fund", l: "Fondo" },
      { k: "reference", l: "Riferimento" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["date", "description", "account", "debit", "credit"],
  },
  deadlines: {
    title: "Scadenzario", singular: "Scadenza",
    fields: [
      { k: "title", l: "Titolo", req: true }, { k: "due_date", l: "Data scadenza", t: "date", req: true },
      { k: "category", l: "Categoria", t: "select", o: opt("Fiscale", "Legale", "Amministrativa", "Antiriciclaggio", "Contabile", "Altro") },
      { k: "status", l: "Stato", t: "select", o: opt(["pendente", "Pendente"], ["completata", "Completata"], ["scaduta", "Scaduta"], ["annullata", "Annullata"]) },
      { k: "priority", l: "Priorità", t: "select", o: opt(["bassa", "Bassa"], ["media", "Media"], ["alta", "Alta"], ["urgente", "Urgente"]) },
      { k: "description", l: "Descrizione", t: "textarea" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["due_date", "title", "category", "priority", "status"],
    defaults: { status: "pendente", priority: "media" },
  },
  fiscal: {
    title: "Gestione Fiscale", singular: "Adempimento fiscale",
    fields: [
      { k: "type", l: "Tipo", t: "select", req: true, o: opt(["dichiarazione", "Dichiarazione"], ["ritenuta", "Ritenuta"], ["imposta_ires", "Imposta IRES"], ["adempimento", "Adempimento"], ["calcolatore", "Calcolo"]) },
      { k: "year", l: "Anno", t: "number", req: true }, { k: "description", l: "Descrizione", req: true },
      { k: "taxable_income", l: "Imponibile", t: "number" }, { k: "tax_rate", l: "Aliquota %", t: "number" }, { k: "tax_due", l: "Imposta dovuta", t: "number" },
      { k: "advance_payment", l: "Acconto", t: "number" }, { k: "amount", l: "Importo", t: "number" },
      { k: "status", l: "Stato", t: "select", o: opt(["bozza", "Bozza"], ["calcolato", "Calcolato"], ["presentato", "Presentato"], ["pagato", "Pagato"]) },
      { k: "due_date", l: "Scadenza", t: "date" }, { k: "paid_date", l: "Data pagamento", t: "date" }, { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["year", "type", "description", "tax_due", "status"],
    defaults: { status: "bozza", year: new Date().getFullYear() },
  },
  diary: {
    title: "Diario del Trust", singular: "Evento",
    fields: [
      { k: "date", l: "Data", t: "date", req: true }, { k: "title", l: "Titolo", req: true },
      { k: "category", l: "Categoria", t: "select", o: opt("Riunione", "Comunicazione", "Delibera", "Adempimento", "Altro") },
      { k: "description", l: "Descrizione", t: "textarea" },
    ],
    columns: ["date", "title", "category"],
  },
  chart_of_accounts: {
    title: "Piano dei Conti", singular: "Conto",
    fields: [
      { k: "code", l: "Codice", req: true }, { k: "name", l: "Denominazione", req: true },
      { k: "type", l: "Tipo", t: "select", req: true, o: opt(["attivo", "Attivo"], ["passivo", "Passivo"], ["ricavi", "Ricavi"], ["costi", "Costi"]) },
      { k: "level", l: "Livello", t: "number" }, { k: "is_leaf", l: "Conto movimentabile", t: "bool" }, { k: "description", l: "Descrizione", t: "textarea" },
    ],
    columns: ["code", "name", "type", "level", "is_leaf"],
    sort: (a, b) => String(a.code).localeCompare(String(b.code), "it", { numeric: true }),
  },
  prospects: {
    title: "Nuovi Clienti", singular: "Prospect",
    fields: [
      { k: "status", l: "Stato", t: "select", o: opt(["nuovo", "Nuovo"], ["in_consulenza", "In consulenza"], ["anagrafica_trust", "Anagrafica Trust"]) },
      { k: "last_name", l: "Cognome", req: true }, { k: "first_name", l: "Nome", req: true }, { k: "gender", l: "Sesso", t: "select", o: opt("M", "F") },
      { k: "tax_code", l: "Codice fiscale" }, { k: "birth_date", l: "Data di nascita", t: "date" }, { k: "birth_place", l: "Luogo di nascita" },
      { k: "address", l: "Indirizzo" }, { k: "city", l: "Città" }, { k: "province", l: "Provincia" }, { k: "postal_code", l: "CAP" },
      { k: "country", l: "Paese" }, { k: "email", l: "Email" }, { k: "phone", l: "Telefono" }, { k: "pec", l: "PEC" },
      { k: "id_doc_type", l: "Tipo documento", t: "select", o: opt("Carta d'identità", "Patente", "Passaporto") },
      { k: "id_doc_number", l: "Numero documento" }, { k: "id_doc_expiry_date", l: "Scadenza documento", t: "date" },
      { k: "occupation", l: "Professione" }, { k: "employer", l: "Datore di lavoro" }, { k: "annual_income", l: "Reddito annuo / fatturato" },
      { k: "employees", l: "Dipendenti" }, { k: "children", l: "Figli" }, { k: "marital_regime", l: "Regime matrimoniale" },
      { k: "meeting_date", l: "Data dell'incontro", t: "date" }, { k: "consulting_fee", l: "Compenso consulenza (Euro)" },
      { k: "marketing_consent", l: "Consenso marketing (newsletter GetResponse)", t: "bool" }, { k: "marketing_consent_date", l: "Data consenso marketing", t: "date" },
      { k: "marketing_consent_source", l: "Fonte del consenso", t: "select", o: opt("Modulo firmato", "Email", "Sito web", "Colloquio", "Altro") },
      { k: "gr_status", l: "GetResponse", t: "select", ro: true, o: GR_STATUS },
      { k: "notes", l: "Note", t: "textarea" },
    ],
    columns: ["last_name", "first_name", "email", "phone", "status", "gr_status"],
    defaults: { status: "nuovo", country: "Italia" },
  },
};
